import React from 'react'
import { GlobalDataContext, useAccountStore } from '../../common'

export const useAccountUiStore = () => {
  const context = React.useContext(GlobalDataContext)

  if (!context) {
    throw new Error('useCategoryUiStore() must be used within the GlobalDataContext')
  }

  return useAccountStore().uiStore
}
